import { IconArrowLeft } from "@tabler/icons-react";
import {useDB} from "../Services/useDB";
import {useEffect, useState} from "react";
import EventForm from "../Components/Event/EventForm";
import EventDelete from "../Components/Event/EventDelete";

export function System() {

    const { getSettings } = useDB();
    const [settings, setSettings] = useState([]);


    useEffect(() => {
        const fetchSettings = async () => {
            const systemData = await getSettings();
            setSettings(systemData);
        };

        fetchSettings();
    }, []);

    return (
        <div className="container-fluid mt-4">
            <div className="row row-cards">

                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                <h3 className="card-title mb-0">Events</h3>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-vcenter card-table table-hover">
                                <thead>
                                <tr>
                                    <th>Event Name</th>
                                    <th>Datum</th>
                                    <th>Event URL</th>
                                    <th>Rahmenbild</th>
                                    <th>Overlaybild</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}